import React, { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";

function ContactTable({ Contacts,onView }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID de contact</TableCell>
            <TableCell>E-mail</TableCell>
            <TableCell>Sujet</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Contacts
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((contact,index) => (
              <TableRow key={contact?.id} onClick={(event) => onView(contact, event)}>
                <TableCell>#{index+1}</TableCell>
                <TableCell>{contact?.mail}</TableCell>
                <TableCell>{contact?.subject}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={Contacts.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
}

export default ContactTable;
